import { zodResolver } from '@hookform/resolvers/zod';
import { Button } from '@optools/components/ui/button';
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@optools/components/ui/form';
import { Input } from '@optools/components/ui/input';
import { cn } from '@optools/components/ui/utils';
import { add, differenceInSeconds } from 'date-fns';
import { useForm } from 'react-hook-form';
import * as z from 'zod';

const schema = z.object({
  absoluteTime: z.iso.datetime({ error: 'Please enter a valid timestamp' }),
});

export interface TrimTimeFormProps {
  onSubmit: (time: number) => void;
  programDateTime: string;
  videoTime: number;
}

export function TrimTimeForm({ onSubmit, programDateTime, videoTime }: TrimTimeFormProps) {
  const form = useForm({
    defaultValues: { absoluteTime: add(programDateTime, { seconds: videoTime }).toISOString() },
    resolver: zodResolver(schema),
  });

  const handleSubmit = (values: z.infer<typeof schema>) => {
    onSubmit(differenceInSeconds(values.absoluteTime, programDateTime));
  };

  return (
    <Form {...form}>
      <form
        aria-label="absolute time"
        className="flex items-end gap-2"
        onSubmit={form.handleSubmit(handleSubmit)}>
        <FormField
          control={form.control}
          name="absoluteTime"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="text-xs">Absolute Time (UTC)</FormLabel>
              <FormControl>
                <Input {...field} />
              </FormControl>
              <FormMessage className="text-xs" />
            </FormItem>
          )}
        />
        <Button className={cn({ 'self-center': form.formState.errors.absoluteTime })} type="submit">
          Submit
        </Button>
      </form>
    </Form>
  );
}
